<div class="display-flex margin-top-1">
    <div class="font-size-xxlarge icon-locked icon-color"></div>
    <div class="justify-content-left">
        <h6 class="margin-top-0">{{ plan?.plan?.name}}</h6>
        <span class="font-size-xsmall" *ngIf="plan?.dueDate">{{ 'LEARNING_STATUS_DUE' | translate}} {{ plan.dueDate | date: 'longDate'}}</span>
    </div>
</div>
